import type { AirportBusPassengerTypeOption, AirportBusProviderConfig } from "../config/types";

export function getAirportBusPassengerTypeByCode(
  config: AirportBusProviderConfig,
  code: string
): AirportBusPassengerTypeOption | undefined {
  return config.passengerTypes.find(type => type.code === code);
}

export function isAirportBusPassengerTypeCode(config: AirportBusProviderConfig, code: string): boolean {
  return config.passengerTypes.some(type => type.code === code);
}

export function createInitialAirportBusPassenger(
  config: AirportBusProviderConfig,
  hasRemove = false
): {
  first_name: string;
  last_name: string;
  passenger_type: string;
  hasRemove: boolean;
} {
  return {
    first_name: "",
    last_name: "",
    passenger_type: config.defaultPassengerTypeCode,
    hasRemove
  };
}
